import axios from "axios";
import qs from "qs";
import {
    getStudents,
    getToken,
    isTrue,
    QuestionType,
    toNumber
} from "./service";

import _ from "underscore";
import { OrderTopicType } from "pages/exam/addExam";
import Config from "config";
import Storage from "../utils/Storage";

export interface PaperParams {
    courseNo: string;
    courseSeq: string;
    week: string; // 星期几
    weekTime: string; // 第几周
    section: string;
    continunity: string;
    weekTimeId: string;
}

export enum OptionIsRight {
    Right = "1",
    Wrong = "0"
}

// 作业批改状态
export enum PaperState {
    NotMatch = "0", // 没有试卷
    NotSubmit = "1", // 未提交
    Reviewed = "2", // 已批改
    NotReviewed = "3", // 未批改
    Expire = "4" // 已过期
}

export interface TopicType {
    topicId?: string;
    tempTopicId: string;
    topicType: QuestionType;
    trunk: string; // 题干
    answers: OptionType[];
    contentText: string; // 主观题正文
    score: number;
    fileList?: string[]; //描述预览列表
    officeUrl?: string; //office前缀
    trunkFileList?: string[]; //题干阅览列表
    trunkOfficeUrl?: string; //office前缀
    topics: TopicType[];
}

export interface OptionType {
    answerId?: string;
    content: string;
    isRight: OptionIsRight;
    isChoose?: OptionIsRight;
}

export interface StuPaperListItem {
    paperId: number;
    studentId: number;
    studentName: string;
    score: string;
    endTime: string;
    state: PaperState;
    notes: string;
    oldScore: number;
}

// 空选项
export function getEmptyOption(text: string = "") {
    return {
        content: text,
        isRight: OptionIsRight.Wrong
    };
}

// 空单选题
export function getEmptyTopicChoice(type: QuestionType): OrderTopicType {
    const answers =
        type === QuestionType.PanDuan
            ? [getEmptyOption("正确"), getEmptyOption("错误")]
            : [
                  getEmptyOption(),
                  getEmptyOption(),
                  getEmptyOption(),
                  getEmptyOption()
              ];

    return {
        tempTopicId: Math.random().toString(),
        topicType: type,
        trunk: "",
        answers:
            type === QuestionType.ZhuGuan
                ? [{ isRight: OptionIsRight.Right, content: "" }]
                : answers,
        contentText: "",
        score: 0,
        order: 999,
        topics: []
    };
}

export function getEmptyTopicCompound(type: QuestionType) {
    return {
        tempTopicId: Math.random().toString(),
        topicType: type,
        trunk: "",
        answers: [],
        contentText: "",
        score: 0,
        order: 999,
        topics: []
    };
}

export interface PaperType {
    id: number | EmptyValue;
    score: string;
    date: string;
    ispublish: BooleanValue;
    isHomeworkComplete: BooleanValue; // 作业是不是已经有学生在做 1. 已做, 0 未作
    topics: TopicType[];
}

/**
 * 获取整个试卷数据
 * @param params
 */
export function getPaper(params: PaperParams): Promise<PaperType | EmptyValue> {
    const token = getToken();

    return axios
        .post<SuccessData<PaperType | EmptyValue>>(
            "teacher/paper",
            qs.stringify(params),
            { headers: { token } }
        )
        .then(res => res.data.data)
        .then(data => {
            if (!data) return data;
            if (!data.topics) return data;
            const topics = data.topics.map(item => {
                item.tempTopicId = item.topicId || Math.random().toString();
                item.topics = item.topics.map(item => ({
                    ...item,
                    tempTopicId: item.topicId || Math.random().toString()
                }));
                return item;
            });
            // const topics = data.topics.map(item => ({...item, tempTopicId: item.topicId || Math.random().toString()}));
            return { ...data, topics };
        });
}

/**
 * 获取一张试卷的试题(不带试题id等)
 * @param params
 */
export function getTopicsFromPaper(params: PaperParams) {
    return getPaper(params)
        .then(data => (data && data.topics ? data.topics : []))
        .then(topics => {
            return topics.map(topic => {
                topic.topicId = undefined;
                topic.tempTopicId = Math.random().toString();
                topic.answers = topic.answers.map(answer => {
                    answer.answerId = undefined;
                    return answer;
                });
                return topic;
            });
        });
}

/**
 * 获取一张试卷的试题(不带试题id等) 检查所有学期中是否有试题，复制作业专用
 * @param params
 */

export interface CopayPaperProps extends PaperParams {
    batchNo: string;
}

export interface CopyDetailProps extends StuTopics {
    topicType: QuestionType;
    topics: CopyDetailProps[];
    tempTopicId: string;
}

function RecursionTop(topics: CopyDetailProps[]) {
    topics.forEach(topic => {
        topic.tempTopicId = Math.random().toString();
        topic.type = topic.topicType;
        topic.answers = topic.answers.map(answer => {
            answer.isChoose = isTrue(answer.isRight)
                ? OptionIsRight.Right
                : OptionIsRight.Wrong;
            return answer;
        });
        if (topic.topics) {
            RecursionTop(topic.topics);
        }
    });
    return topics;
}

export function getCopyPaper(params: CopayPaperProps) {
    //  StuTopics 作业历史遗留恶心问题。如果你看到了这个，恭喜你，你进入了新一轮的答辩！啊啊啊啊啊啊啊啊啊啊 只能写个StuTopics类型了
    return axios
        .post<SuccessData<CopyDetailProps>>(
            "teacher/paper2",
            qs.stringify(params)
        )
        .then(res => res.data.data)
        .then(data => (data && data.topics ? data.topics : []))
        .then(topics => {
            return RecursionTop(topics);
        });
}

/**
 * 保存试题
 */
export function setPaperTopic(
    paperParams: PaperParams,
    paperId: string | EmptyValue,
    topicId: string | EmptyValue,
    trunk: string,
    type: QuestionType,
    topic: TopicType
) {
    const token = getToken();
    const topics = topic.topics.map(topic => ({
        ...topic,
        paperId,
        type: topic.topicType
    }));

    return axios
        .post<SuccessData<string>>(
            "teacher/topic",
            qs.stringify({
                ...paperParams,
                paperId,
                topicId,
                trunk,
                type,
                answers: JSON.stringify(topic.answers),
                topics: JSON.stringify(topics),
                score: topic.score,
                contentText: topic.contentText,
                operation: 3,
                groupType: 1
            }),
            { headers: { token } }
        )
        .then(res => res.data.message);
}
/**
 * 保存试题
 */

export interface SaveChooseTopicProps {
    weekTimeId: string;
    paperId: string;
    data: { questionId: string; score: number }[];
}
export function saveChooseTopic(data: SaveChooseTopicProps) {
    return axios
        .post<SuccessData<string>>("teacher/saveChooseTopic", {
            ...data,
            operation: 3,
            groupType: 1
        })
        .then(res => res.data.message);
}

/**
 * 批量保存试题
 */
export function topicsSaveAll(
    paperParams: PaperParams,
    topics: TopicType[]
): Promise<TopicType[]> {
    const token = getToken();
    return axios
        .post<SuccessData<TopicType[]>>(
            "teacher/topicsSave",
            qs.stringify({
                ...paperParams,
                topics: JSON.stringify(topics.map(formatTopicForSave))
            }),
            { headers: { token } }
        )
        .then(res => res.data.data)
        .then(topics => {
            return topics.map(item => ({
                ...item,
                tempTopicId: item.topicId || Math.random().toString()
            }));
        });
}

/**
 * 格式化试题
 */
export function formatTopicForSave(topic: TopicType) {
    const typescript = "";
    const answers =
        topic.answers.length === 0
            ? [{ isRight: "", content: "" }]
            : topic.answers;
    return { type: topic.topicType, ...topic, typescript, answers };
}

/**
 * 保存试卷接口
 */
export function savePaper({
    paperParams,
    score,
    date
}: {
    paperParams: PaperParams;
    score: number;
    date: string;
}) {
    const token = getToken();
    const operation = 3;
    return axios.post(
        `teacher/updatePaper`,
        qs.stringify({ ...paperParams, score, date, operation }),
        { headers: { token } }
    );
}

/**
 * 删除试卷接口
 */
export interface DeleteHomeWorkProps {
    courseNo: string; // 课程编号
    courseSeq: string; // 课序号
    weekTime: string; // 星期几
    week: string; // 第几周
    section: string; //
    weekTimeId: string; //
    id: number; // 课程ID
}
export function DeleteHomeWorkProps(data: DeleteHomeWorkProps) {
    return axios.post(`/teacher/deleteCoursePaper`, qs.stringify(data));
}

/**
 * 取消发布
 * @param paperParams
 */
export function cancelPaper(paperParams: PaperParams) {
    const token = getToken();
    const operation = 3;
    return axios.post(
        `teacher/updatePaperIspublish`,
        qs.stringify({ ...paperParams, operation }),
        { headers: { token } }
    );
}

/**
 * 删除题目
 * @param topics
 */
export function removeTopics(
    topics: TopicType[],
    paperId: string
): Promise<void> {
    const token = getToken();
    const ids = topics.filter(item => item.topicId).map(item => item.topicId);
    if (ids.length === 0) return Promise.resolve();
    return axios.post(
        `teacher/topicDel`,
        qs.stringify({ topics: ids.join(","), paperId: paperId }),
        { headers: { token } }
    );
}

/**
 * 获取学员作业列表
 * @param paperParams
 */
export function getStuPaperList(paperParams: PaperParams) {
    const token = getToken();
    return axios
        .get<SuccessData<StuPaperListItem[]>>(
            `teacher/stuPaper?${qs.stringify(paperParams)}`,
            { headers: { token } }
        )
        .then(res => res.data.data);
}

/**
 * 批量导入修改分数
 */
export function exportUpdateScore(file: File, paperId: string) {
    const headers = { "Content-Type": "multipart/Form-data" };
    const formData = new FormData();
    formData.append("file", file);
    formData.append("paperId", paperId);
    return axios.post(`/teacher/exportUpdateScore`, formData, {
        headers
    });
}

/**
 * 获取所有学员的作业列表
 */
export async function getAllStuPaper(paperParams: PaperParams) {
    const paperPromise = getPaper(paperParams);
    const studentsPromise = getStudents(
        paperParams.courseNo,
        paperParams.courseSeq
    );
    const paperListPromise = getStuPaperList(paperParams);

    const students = await studentsPromise;
    const paperList = await paperListPromise;
    const paperData = await paperPromise;

    if (!paperData || !isTrue(paperData.ispublish)) return [];
    return students.map(student => ({
        ...student,
        paperId: paperData.id,
        homework: _.find(paperList, { studentId: parseInt(student.studentId) })
    }));
}

export interface StuAnswer {
    answerId: number;
    content: string;
    isRight: "0" | "1";
    isChoose: "0" | "1";
    stuAnswer: string;
}

export interface StuTopics {
    topicId: number;
    type: QuestionType;
    typescript: string;
    trunk: string;
    score: string;
    markScore: string;
    contentText: string;
    isRight: "0" | "1";
    topics: StuTopics[];
    answers: StuAnswer[];
    comment?: string | undefined;
}

export interface StuPaper {
    paperId: number;
    studentId: number;
    studentName: string;
    score: string;
    objectiveScore: string;
    endTime: string;
    className: string;
    courseName: string;
    topics: StuTopics[];
}

/***
 * 获取学员作业详细
 */
export function getStudPaper(args: { paperId: string; studentId: string }) {
    const token = getToken();
    return axios
        .get<SuccessData<StuPaper>>(`teacher/studentPaper`, {
            params: args,
            headers: { token }
        })
        .then(res => res.data.data);
}

/***
 * 获取学员作业详细2
 */
export function getStudPaper2(args: { paperId: string; studentId: string }) {
    const token = getToken();
    return axios
        .get<SuccessData<StuPaper>>(`teacher/studentPaper2`, {
            params: args,
            headers: { token }
        })
        .then(res => res.data.data);
}

/**
 * 主观题判分
 * @param args
 */
export function saveScore(args: {
    paperId: string;
    studentId: string;
    topicId: number;
    parentId?: number;
    markScore: number;
    comment: string;
}) {
    const token = getToken();
    return axios.post(`teacher/teacherMark`, qs.stringify(args), {
        headers: { token }
    });
}

/**
 * 计算总分
 */
export function countTotalScore(topics: TopicType[]) {
    return parseFloat(
        _.reduce(
            topics,
            (total, item) => total + toNumber(item.score),
            0
        ).toFixed(1)
    );
}

/**
 * 保存试题时检查选项是不是完整
 */
export function checkTopic(
    topic: TopicType,
    noCheck?: { trunk: boolean }
): { result: "success" | "error"; msg?: string } {
    if (topic.topicType === QuestionType.TianKong) {
        if (topic.answers.findIndex(answer => answer.content === "") >= 0)
            return { result: "error", msg: "填空题答案不能为空！" };
    }

    if (
        topic.topicType !== QuestionType.ZhuGuan &&
        !_.any(topic.answers, option => isTrue(option.isRight))
    ) {
        return { result: "error", msg: "至少选择一个正确答案!" };
    }
    if ((!noCheck || !noCheck.trunk) && !topic.trunk) {
        return { result: "error", msg: "请填写题目内容!" };
    }

    if (toNumber(topic.score) === 0) {
        return { result: "error", msg: "请为题目设置分值!" };
    }

    return { result: "success" };
}

export function exportHomework(params: PaperParams) {
    const token = getToken();
    const batch = Storage.get("batch") || Config.DefaultBatch;
    window.open(
        `${Config.ApiHost}teacher/downHomework?token=${btoa(
            token || ""
        )}&${qs.stringify({ ...params, batchNo: batch })}`
    );
}

export interface exportHomeworkItem {
    name: string;
    studentNo: string;
    className: string;
    score: string;
}

export function homeworkTopicSort(paperId: string, topics: string[]) {
    const token = getToken();
    return axios.post(
        `teacher/homeworkTopicSort`,
        qs.stringify({ paperId, topics: topics.join(",") }),
        { headers: { token } }
    );
}

/**
 * 列表修改成绩
 */
export interface UpdateStuScoreProps {
    paperId: number;
    score: number;
    notes: string;
    studentId: number;
}
export function updateStuScore(data: UpdateStuScoreProps) {
    return axios.post(`teacher/updateStuScore`, qs.stringify(data));
}

/**
 * 作业题型排序
 */
export function topicTypeSort(paperId: number, types: string[]) {
    const token = getToken();
    return axios.post(
        `teacher/topicTypeSort`,
        qs.stringify({ paperId, types: types.join(",") }),
        { headers: { token } }
    );
}

export interface WeekTimePaper {
    paperId: string;
    workStatus: "0" | "1"; // 0：待发布 1：已发布
    endTime: string;
    paperName: string;
    readOnly: BooleanValue; //是否可以编辑
    lastEditTeacher: string; //上次编辑的老师
}

/**
 * (作业)教师端-获取某节课作业
 */
export function getWeekTimePaper(weekTimeId: number) {
    const token = getToken();
    return axios
        .post<SuccessData<WeekTimePaper>>(
            `teacher/getWeekTimePaper`,
            qs.stringify({ weekTimeId }),
            { headers: { token } }
        )
        .then(res => res.data.data);
}

//打包下载学生试卷
export function downloadAllHomeworkPaper(weekTimeId: string) {
    return axios.post(
        `/teacher/downloadAllHomeworkPaper`,
        qs.stringify({ weekTimeId })
    );
}

export interface ZipPaperListItem {
    persistId: string;
    uuid: string;
    url: string;
    statusCode: string; //状态为0的时候才能下载
    status: string;
    fileName: string;
}

//获取试卷下载任务列表
export function getZipHomeWorkList(weekTimeId: string) {
    const batchNo = Storage.get("batch") || Config.DefaultBatch;

    return axios
        .get<SuccessData<{ [key: string]: ZipPaperListItem[] }[]>>(
            `/teacher/getZipHomeWorkList`,
            { params: { weekTimeId }, headers: { batchNo } }
        )
        .then(res => res.data.data);
}

//获取试卷下载任务列表
export interface getHomeWorkPaperProps {
    batchNo: string; //学期no（单个）
    courseNo: string; //课程no
    courseSeq: string; //课程seq
}

export interface getHomeWorkPaperListProps {
    courseNo: string; //课程编码
    courseSeq: string; //课程序号
    weekTime: string; //第几周
    week: string; //星期几
    section: string;
    continunity: string;
    batchNo: string; //学期no
    paperId: string; //作业id
    weekTimeId: string; //周次节id
    createTime: string; //作业创建时间
    topicCount: string; //题数
    batchName: string; //学期名称
    courseName: string;
    key: string;
    score: string; // 分数
}

export function getHomeWorkPaperList(data: getHomeWorkPaperProps) {
    return axios
        .post<SuccessData<getHomeWorkPaperListProps[]>>(
            `/teacher/getHomeWorkPaperList`,
            qs.stringify(data)
        )
        .then(res => res.data.data)
        .then(data => {
            return data.map(item => {
                return {
                    ...item,
                    key: `${item.courseNo}${item.courseSeq}${item.batchNo}${item.createTime}`
                };
            });
        });
}

//恢复修改成绩
export function restoreStudentScore(studentId: string, paperId: number) {
    return axios.post(
        `/teacher/restoreStudentScore`,
        qs.stringify({ studentId, paperId })
    );
}
